import React, { useState } from "react";
import axios from "axios";
import DesignationSelect from "./DesignationSelect";
import DepartmentSelect from "./DepartmentSelect";
import EmploymentTypeSelect from "./EmploymentTypeSelect";
import EmploymentStatusSelect from "./EmploymentStatusSelect";
import WorkPreferenceSelect from "./WorkPreferenceSelect";
import ShiftSelect from "./ShiftSelect";
import ReportingSelect from "./ReportingSelect";

const apiUrl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

const EmployeeListFilter = ({ onFilterApplied }) => {
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [designation, setDesignation] = useState("");
  const [department, setDepartment] = useState("");
  const [employmentType, setEmploymentType] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [workPreference, setWorkPreference] = useState("");
  const [shift, setShift] = useState("");
  const [reporting, setReporting] = useState("");

  const handleEmployeeIdChange = (e) => setEmployeeId(e.target.value);
  const handleEmployeeNameChange = (e) => setEmployeeName(e.target.value);
  const handleDesignationChange = (selectedOption) => setDesignation(selectedOption ? selectedOption.value : "");
  const handleDepartmentChange = (selectedOption) => setDepartment(selectedOption ? selectedOption.value : "");
  const handleEmploymentTypeChange = (selectedOption) => setEmploymentType(selectedOption ? selectedOption.value : "");
  const handleEmploymentStatusChange = (selectedOption) => setEmploymentStatus(selectedOption ? selectedOption.value : "");
  const handleWorkPreferenceChange = (selectedOption) => setWorkPreference(selectedOption ? selectedOption.value : "");
  const handleShiftChange = (selectedOption) => setShift(selectedOption ? selectedOption.value : "");
  const handleReportingChange = (selectedOption) => setReporting(selectedOption ? selectedOption.value : "");

  const handleSearch = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employees/list`, {
        params: {
          employeeId,
          employeeName,
          designation,
          department,
          employmentType,
          employmentStatus,
          workPreference,
          shift,
          reporting,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onFilterApplied(response.data.employees); // Pass filtered data to parent component
    } catch (error) {
      console.error("Error fetching filtered employees:", error);
    }
  };

  const handleReset = () => {
    setEmployeeId("");
    setEmployeeName("");
    setDesignation("");
    setDepartment("");
    setEmploymentType("");
    setEmploymentStatus("");
    setWorkPreference("");
    setShift("");
    setReporting("");

    handleSearch(); // Call the API to fetch all data after reset
  };

  return (
    <div
      className="modal custom-modal fade"
      id="scrollable-modal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="scrollableModalTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg"
        style={{
          margin: 0,
          position: "fixed",
          right: 0,
          height: "100vh",
          width: "40%",
        }}
        role="document"
      >
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title" id="scrollableModalTitle">
              Filter
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
          >
            <div className="row">
              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Employee ID:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={employeeId}
                    onChange={handleEmployeeIdChange}
                    placeholder="Enter Employee ID"
                    style={{ width: "300px" }}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Name:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={employeeName}
                    onChange={handleEmployeeNameChange}
                    placeholder="Enter Name"
                    style={{ width: "300px" }}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Designation:</label>
                  <DesignationSelect onChange={handleDesignationChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Department:</label>
                  <DepartmentSelect onChange={handleDepartmentChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Employment Type:</label>
                  <EmploymentTypeSelect onChange={handleEmploymentTypeChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Employment Status:</label>
                  <EmploymentStatusSelect onChange={handleEmploymentStatusChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Work Preference:</label>
                  <WorkPreferenceSelect onChange={handleWorkPreferenceChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Shift:</label>
                  <ShiftSelect onChange={handleShiftChange} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 mb-3">
                <div className="form-group d-flex align-items-center" style={{ borderBottom: "1px solid #dcdcdc", paddingBottom: "10px" }}>
                  <label className="form-label me-2" style={{ minWidth: "150px" }}>Reporting:</label>
                  <ReportingSelect onChange={handleReportingChange} />
                </div>
              </div>

            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSearch}
            >
              Apply
            </button>
            <button
              type="button"
              className="btn btn-light"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListFilter;
